import { Pipe } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';

@Pipe({
  name: 'isRequired',
  standalone: false,
})
export class IsRequired {
  transform(validators: ValidatorFn[]): boolean {
    return (validators || []).some(validator => validator === Validators.required);
  }
}
